import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CustomSnackbarComponent } from '../components/custom-snackbar/custom-snackbar.component';

@Injectable({
  providedIn: 'root'
})
export class AppSnackbarService {

  constructor(private snackBar: MatSnackBar) { }

  open(title: string, message?: string, duration?: number): void {
    const snackBarRef = this.snackBar.openFromComponent(CustomSnackbarComponent, {
      duration: duration ?? 5000,
      horizontalPosition: 'right',
      verticalPosition: 'bottom',
      panelClass: ['custom-snackbar-container'],
      data: {
        title,
        message
      }
    });

    if (!message) {
      snackBarRef.instance.titleOnly = true;
    }
  }
}
